import { checkCookieConsent, consentToCookies } from "@/assets/js/utils.js"

const state = {
  showCookieConsent: false,
  appCookieDomain: ""
}

const getters = {
  getShowCookieConsent: (state) => state.showCookieConsent,
  getAppCookieDomain: (state) => state.appCookieDomain,
}

const mutations = {
  setShowCookieConsent: (state, payload) => (state.showCookieConsent = payload),
  setAppCookieDomain: (state, payload) => (state.appCookieDomain = payload),
}

const actions = {
  checkCookieConsent({ commit }) {
    const consentNeeded = !checkCookieConsent()
    commit("setShowCookieConsent", consentNeeded)
  },
  consentToCookies({ commit }) {
    consentToCookies()
    commit("setShowCookieConsent", false)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
